import { resolveConfigOrExit } from '@next-adapter/config/resolve-config-or-exit.js'
import { getAllComponentNamesForConfig } from '../update-component/get-all-component-names-for-config.js'

export async function listComponentChoices(cwd: string): Promise<string[]> {
  const config = await resolveConfigOrExit(cwd)
  return getAllComponentNamesForConfig(config)
}
